import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { getTranslatedString } from 'helpers/i18n';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import { BounceLoader } from 'halogenium';

import { AccentColor } from 'helpers/AccentColorHelper';
import nueraConfig from 'config/services/nuera';

import { hostIsBgoResidents } from 'helpers/CurrentWindowLocation';

export const NueraDialog = ({
  isOpen,
  toggleDialog,
  birthday,
  leaseStartDate,
  street,
  unit,
  province,
  city,
  email,
  phoneNumber,
  tenantId,
  fullScreen,
}) => {
  const [loading, setLoading] = useState(true);
  const { src } = nueraConfig;

  let iframeSrc = src;
  if (hostIsBgoResidents()) {
    iframeSrc += `?rf=BGO-YUHU`;
  } else {
    iframeSrc += `?rf=YUHU`;
  }
  if (birthday) iframeSrc += `&dateOfBirth=${moment(birthday).locale('en').format('DD-MMM-YYYY')}`;
  if (leaseStartDate)
    iframeSrc += `&effectiveDate=${moment(leaseStartDate).locale('en').format('DD-MMM-YYYY')}`;
  if (street) iframeSrc += `&addressStreetAddress=${street}`;
  if (unit) iframeSrc += `&addressUnitNumber=${unit}`;
  if (province) iframeSrc += `&addressProvince=${province}`;
  if (city) iframeSrc += `&addressCity=${city}`;
  if (email) iframeSrc += `&email=${email}`;
  if (phoneNumber) iframeSrc += `&phoneNumber=${phoneNumber}`;
  if (tenantId) iframeSrc += `&webhookid=${tenantId}`;

  return (
    <Dialog open={isOpen} fullScreen={fullScreen}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '800px',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {loading ? (
          <div
            style={{
              alignSelf: 'center',
              position: 'absolute',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <p>
              <BounceLoader color={AccentColor()} />
            </p>
            <p>{getTranslatedString('tenantPortal.nueraDialog.directingYou')}</p>
          </div>
        ) : null}
        <iframe
          title="Nuera"
          height="800"
          src={encodeURI(iframeSrc)}
          onLoad={() => setLoading(false)} // TODO after load nuera is still slow at loading, so add timeout?
        />
      </div>
      <DialogActions>
        <FlatButton
          onClick={() => {
            setLoading(true);
            toggleDialog();
          }}
          id="close-button"
          style={{ color: AccentColor() }}
        >
          {getTranslatedString('close')}
        </FlatButton>
      </DialogActions>
    </Dialog>
  );
};

export const redirectToNuera = (params) => {
  // Note: Nuera in iframe was not working so a quick fix to redirect users to a new tab for now

  const { src } = nueraConfig;

  let iframeSrc = src;
  if (hostIsBgoResidents()) {
    iframeSrc += `?rf=BGO-YUHU`;
  } else {
    iframeSrc += `?rf=YUHU`;
  }
  if (params['birthday'])
    iframeSrc += `&dateOfBirth=${moment(params['birthday']).locale('en').format('DD-MMM-YYYY')}`;
  if (params['leaseStartDate'])
    iframeSrc += `&effectiveDate=${moment(params['leaseStartDate'])
      .locale('en')
      .format('DD-MMM-YYYY')}`;
  if (params['street']) iframeSrc += `&addressStreetAddress=${params['street']}`;
  if (params['unit']) iframeSrc += `&addressUnitNumber=${params['unit']}`;
  if (params['province']) iframeSrc += `&addressProvince=${params['province']}`;
  if (params['city']) iframeSrc += `&addressCity=${params['city']}`;
  if (params['email']) iframeSrc += `&email=${params['email']}`;
  if (params['phoneNumber']) iframeSrc += `&phoneNumber=${params['phoneNumber']}`;
  if (params['tenantId']) iframeSrc += `&webhookid=${params['tenantId']}`;

  window.open(iframeSrc, '_blank');
};
